import React, { useEffect, useState } from 'react'
import { APISettings } from '../../../config/ApiSettings';

interface IFilePreviewProps {
  containerName: string;
  blobName: string;
  type: 'file' | 'image';
  originalName?: string;
  width: string;
  height: string;
}

const FilePreview = (props: IFilePreviewProps) => {
  const { containerName, blobName, originalName, width, height } = props;

  const [extension, setExtension] = useState<string>('');

  useEffect(() => {
    getFileData();
  }, [])

  const getFileData = async () => {
    let ext = blobName.split('.').pop();
    setExtension(ext!);
  }


  const baseUrl = new APISettings().getApiURL();

  return (
    <div>
      {/* This component uses the URLs directly going through fileStorageApi will not render the files */}
      {
        (extension === 'jpg' || extension === 'png')
          ? (<img width={width} src={`${baseUrl}/fileStorage/GetAsByteArray/${containerName}/${blobName}`} alt={originalName ?? blobName} />)
          : extension === 'pdf'
            ? (<embed src={`${baseUrl}/fileStorage/GetAsByteArray/${containerName}/${blobName}`} width={width} height={height} />)
            : (<div>Could not load file</div>)
      }
    </div>
  )
}

export default FilePreview